module.exports = __webpack_public_path__ + "8574b55f54767734155eb4da04999f07.svg";